import * as React from "react";
import * as _ from "lodash";

import {LanguageDto} from "../../../services/Client";

import SelectField, {SelectedValue} from "../../../components/SelectField";

export interface ILanguageSelectionProps {
    /** Displayed when there's no language selected. */
    placeholder: string;

    /** Data source array. All available languages. */
    languages: LanguageDto[];

    /** Initially selected languages. */
    values?: LanguageDto[];

    /** Callback when the selected languages change. */
    onChange?: (languages: LanguageDto[]) => any;

    readOnly?: boolean;

    searchable?: boolean;

    userLanguage?: string;
}

/** Return the LanguageDto references from the languages array that match values. */
export const selectLanguages = (languages: LanguageDto[], values: LanguageDto[]): LanguageDto[] => (
    languages.filter(language => _.find(values, value => value.vmce === language.vmce) !== undefined)
);

/**
 * LanguageSelection is a select field component enables the selection of
 * languages for LanguageCnrDto. There may be 0..* languages selected.
 */
export const LanguageSelection = (props: ILanguageSelectionProps) => {
    const selectedValues = selectLanguages(props.languages, props.values || []);
    return (
        <SelectField
            placeholder={props.placeholder}
            disabled={props.readOnly}
            multi={true}
            searchable={props.searchable}
            clearable={false}
            dataSource={props.languages}
            value={selectedValues}
            rendererKey={props.userLanguage === 'de'
                ? (language: LanguageDto) => language.nameDe
                : (language: LanguageDto) => language.nameEn}
            onChange={(selectedValue: Array<SelectedValue>) => {
                if (props.onChange) {
                    const selectedLanguage = selectedValue.map(value => value.selectedValue as LanguageDto);
                    props.onChange(selectedLanguage);
                }
            }}
            languageFlag={true}
        />
    );
};

export default LanguageSelection;



// WEBPACK FOOTER //
// ./src/views/AdminView/LanguageTab/LanguageSelection.tsx